import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useRemToPx } from '../hooks/useRemToPx'
import { useMediaQuery } from 'react-responsive'
import { ReactSVG } from 'react-svg'
import BtnIcon from './BtnIcon'
import { Controller } from 'swiper/modules'
import classNames from 'classnames'

interface IProps {
  items: any[]
  className?: string
  renderItem: (item: any, index: number) => React.ReactElement
  initialIndex?: number
  navigation?: boolean
}

function Tabs(props: IProps): React.ReactElement {
  const px = useRemToPx()
  const isMobile = useMediaQuery({
    query: '(max-width: 767px)'
  })
  const [swiper, setSwiper] = React.useState<any>(null)

  const handleNavigation = (direction = 1) => {
    if (!swiper) return

    const { slides } = swiper
    const activeIndex = slides.findIndex(
      (el: HTMLElement) => el.children[0]?.classList?.contains('_active')
    )

    let next = activeIndex + direction

    if (next < 0) next = slides.length - 1
    if (next > slides.length - 1) next = 0

    swiper.slideTo(next)
    slides[next]?.children[0]?.click()
  }

  return (
    <div
      className={classNames('tabs', props.className, {
        _active: !swiper ? false : !swiper.isLocked
      })}
    >
      <div className="tabs__wrapper">
        <Swiper
          modules={[Controller]}
          onSwiper={setSwiper}
          controller={{ control: swiper }}
          initialSlide={props.initialIndex ?? 0}
          slideToClickedSlide={true}
          slidesPerView={'auto'}
          spaceBetween={px * (isMobile ? 2.4 : 3.2)}
        >
          {props.items.map((item, index) => {
            return (
              <SwiperSlide key={index}>
                {props.renderItem(item, index)}
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>

      {props.navigation && (
        <div
          className={classNames('tabs__navigation', {
            'visibility-hidden': !swiper ? true : swiper.isLocked
          })}
        >
          <BtnIcon large onClick={() => handleNavigation(-1)}>
            <ReactSVG
              src={'/i/svg/chevron-left.svg'}
              wrapper={'span'}
            ></ReactSVG>
          </BtnIcon>
          <BtnIcon large onClick={() => handleNavigation()}>
            <ReactSVG
              src={'/i/svg/chevron-right.svg'}
              wrapper={'span'}
            ></ReactSVG>
          </BtnIcon>
        </div>
      )}
    </div>
  )
}

export default Tabs
